import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ReactTagInput from '@pathofdev/react-tag-input';
import Footer from 'Components/Footer';

import { useHistory , Link } from 'react-router-dom';
import Back from 'assets/icon/back.png';
import Branch_manage from 'assets/icon/branch-manage.png';
import Save from 'assets/icon/save.png';
import TabsIcon from 'Components/layout/TabsIcon';
import Increase from 'assets/icon/add_menu.png';
import Delete_Button from 'assets/icon/delete.png';
import Calendar from 'assets/icon/calendar-bg.png';
import { DatePicker, TimePicker, Switch } from 'antd';

//API
import { CreateBranch } from 'actions/branch/index';
import { List } from 'actions/employee/index';
import { loadAuth } from 'actions/auth';


import moment from 'moment';
var dayjs = require('dayjs')
export default function Add() {
  const history = useHistory();
  const dispatch = useDispatch();

  const TimeFormat = 'HH:mm';

  const ContactModel = {
    key: 0,
    name: null,
    phone: []
  }

  const FormModel = {
    active: false,
    name: null,
    period: null,
    phone: [],
    sales_target: null,
    open: null,
    closed: null,
    note: null,
    bill_title: null,
    employee_id: null,
    branche_code: '',
    contacts: [
      ContactModel
    ]
  };

  const [Data, setData] = useState(FormModel);

  const [validated, setValidated] = useState(false);
  const [Employees, setEmployees] = useState([])

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }

    setValidated(true);
    setTimeout(async () => {
      const validator = document.querySelectorAll('.validate-fail');
    if(form.checkValidity() && validator.length === 0){
      const contacts = []
        Data.contacts.forEach((contact, key) => {
          let obj = {}
          obj.name = contact.name
          obj.phone = JSON.stringify(contact.phone)
          contacts.push(obj)
        });

        let formData = new FormData();

        if (Data.employee_id) formData.append("employee_id", Data.employee_id);
        if (Data.branche_code) formData.append("branche_code", Data.branche_code);
        if (Data.name) formData.append("name", Data.name);
        if (Data.phone) formData.append("phone", Data.phone);
        if (Data.address) formData.append("address", Data.address);
        if (Data.open) formData.append("open", dayjs(Data.open).format('HH:mm'));
        if (Data.closed) formData.append("closed", dayjs(Data.closed).format('HH:mm'));
        if (Data.period && Data.period[0]) formData.append("period_start", dayjs(Data.period[0]).format('YYYY-MM-DD'));
        if (Data.period && Data.period[1]) formData.append("period_end", dayjs(Data.period[1]).format('YYYY-MM-DD'));
        if (Data.bill_title) formData.append("bill_title", Data.bill_title);
        if (Data.sales_target) formData.append("sales_target" , Data.sales_target);
        if (Data.note) formData.append("note", Data.note);
        formData.append("active", Data.active);

        Data.contacts.forEach((contact, key) => {
          if(contact.name) formData.append(`contacts[${key}][name]`, contact.name)
          if(contact.phone && contact.phone.length > 0) formData.append(`contacts[${key}][phone]`, JSON.stringify(contact.phone))
        });

        try {
          const response = await dispatch(CreateBranch(formData));
          setData(FormModel)
          if(response){
            history.push('/management');
          }else{
            console.log('failed')
          }
        } catch (error) {
          console.error(error);
        } finally {
          console.log('finally')
        }
    }
    },200)
    
  };

  const GetEmployee = async () => {
    const paramas = {
      branch_has_owner: true,
      user: true
    }
    try {
      const response = await dispatch(List(paramas));
      setEmployees(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {

    }
  }

  const getAuth = async () => {
    try {
      const params = {
        name: ['จัดการสาขา'],
        permission : 'add',
      }
      const response = await dispatch(loadAuth(params));
      // if(response.data.data === 'Unauthorized'){
      //   alert(response.data.message)
      //   history.push('/management');
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const InsertContact = () => {
    const contacts = Data.contacts
    const model = {
      key: Data.contacts.length,
      name: null,
      phone: [],
    }
    contacts.push(model)
    const result = contacts
    setData({ ...Data, contacts: result })
  }

  const RemoveContact = (key) => {
    const contacts = Data.contacts.filter((item) => item.key !== key)
    setData({ ...Data, contacts: contacts })
  }


  useEffect(() => {
    GetEmployee();
    getAuth()
  }, []);

  const lineHeight = {
    lineHeight: "45px"
  };

  function closePage() {
    let path = `/management`;
    history.push(path);
  }

  function addCommas(x) {
    if (typeof x === 'number') {
      return parseInt(x).toLocaleString()
    }
    return parseInt(x.replaceAll(',', '')).toLocaleString()
  }

  return (
    <>
    <Container fluid className="package-container  management-edit bg-mrk">
    <div className="package">
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              <img className="logo pr-2" src={Branch_manage} />
              <b><Link to="/management" className='link-pagination'>การจัดการสาขา</Link> &gt; เพิ่มสาขา</b>
            </h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closePage}
            >
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <div className="modal-header-mobile">
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closePage}
            >
              <img src={Back} />
            </button>
            <h5 className="modal-title" id="exampleModalLabel">
              <img className="logo pr-2" src={Branch_manage} />
              <b><Link to="/management" className='link-pagination'>การจัดการสาขา</Link> &gt; เพิ่มสาขา</b>
            </h5>
          </div>
          <div className="modal-body">
            <Row className="g-0 tabsicon justify-content-center ">
              <TabsIcon />
            </Row>
            <Row className="line-top-form justify-content-center"></Row>

            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="justify-content-center">
                <Col lg={10}>
                  <Row className="d-md-block d-lg-none">
                    <Col className="d-flex justify-content-start ">
                      <Form.Label>
                        <Switch checked={Data.active} onChange={(boolean) => setData({...Data, active: boolean})} />
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start "
                        >
                          <Form.Label className="mt-3">ชื่อสาขา</Form.Label>
                        </Col>
                        <Col>
                          <Form.Control 
                            className="input-search-add-staff"
                            placeholder="ชื่อสาขา"
                            value={Data.name}
                            required
                            onChange={(e) => setData({...Data, name: e.target.value})}
                          ></Form.Control>
                          <p className="text-right m-0">{Data.name && `${Data.name.length}/`}150</p>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      lg={5}
                      className="mt-2 d-flex justify-content-start   d-md-none d-lg-block"
                    >
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start"
                        >
                          <Form.Label>
                            <Switch 
                            checked={Data.active}
                            onChange={(boolean) => setData({...Data, active: boolean})} />
                          </Form.Label>
                        </Col>
                        <Col className="d-flex justify-content-start align-items-center">
                          <Form.Label className="text-bold">
                            {Data.active ? 'เปิดการใช้งาน': 'ปิดการใช้งาน'}
                          </Form.Label>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                   <Row>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start align-items-center"
                        >
                          <Form.Label>รหัสสาขา</Form.Label>
                        </Col>
                        <Col className="d-flex justify-content-end">
                        <Form.Control 
                              className="input-search-add-staff"
                              placeholder="รหัสสาขา"
                              value={Data.branche_code}
                              required
                              onChange={(e) => setData({...Data, branche_code: e.target.value})}
                            ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start align-items-center"
                        >
                          <Form.Label>เบอร์โทรศัพท์</Form.Label>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <div className={'w-100 ' + (!Data.phone | Data.phone.length === 0 && validated ? 'validate-fail-tags' : '') }>
                            <ReactTagInput
                              placeholder="เบอร์โทรศัพท์"
                              editable={true}
                              readOnly={false}
                              removeOnBackspace={true}
                              maxTags={2}
                              tags={Data.phone}
                              onChange={(newTags) => setData({ ...Data, phone: newTags }) }
                              className="input-tage"
                              required
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start"
                        >
                          <Form.Label className="mt-3">ที่อยู่</Form.Label>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <Form.Control
                            as="textarea"
                            placeholder="ที่อยู่"
                            required
                            rows={3}
                            className="input-area-box"
                            value={Data.address}
                            onChange={(e) => setData({...Data, address: e.target.value})}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row className="align-items-center">
                        <Col
                          lg={3}
                          className="d-flex justify-content-start"
                        >
                          <Form.Label>เวลาเปิด-ปิด</Form.Label>
                        </Col>
                        <Col className="">
                          <Row>
                            <Col xs={5} lg={5}>
                              <div className={(!Data.open && validated ? 'validate-fail-date' : '') }>
                                <TimePicker 
                                  placeholder='เวลาเปิด' 
                                  format={TimeFormat} 
                                  defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} 
                                  onChange={(time) => setData({...Data, open: time})}
                                />
                              </div>
                            </Col>
                            <Col
                              xs={2}
                              lg={2}
                              className="d-flex justify-content-center align-items-center"
                            >
                              &ndash;
                            </Col>
                            <Col xs={5} lg={5}>
                              <div className={(!Data.closed && validated ? 'validate-fail-date' : '') }>
                                <TimePicker placeholder='เวลาปิด' format={TimeFormat} defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} onChange={(time) => setData({...Data, closed: time})}/>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  { 
                    Data.contacts?.map((contact, key) => {
                      return (
                        <>
                  <Row className="align-items-center mb-1">
                    <Col lg={10}>
                      <Row className="align-items-center">
                        <Col xs={12} sm={12} lg={6}>
                          <Row className="align-items-center">
                            <Col lg={4} className="text-left">
                              <Form.Label>ชื่อผู้ติดต่อ</Form.Label>
                                </Col>
                                <Col className='set-padding'>
                                <Form.Control 
                                className="input-search-add-staff" 
                                placeholder="ชื่อผู้ติดต่อ"
                                value={contact.name ? contact.name : ''}
                                required
                                onChange={
                                  (e) => setData(prevState => ({
                                    ...Data,
                                    contacts: prevState.contacts.map(
                                      el => el.key === key ? { ...el, name: e.target.value }: el
                                    )
                                  })) 
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12} sm={12} lg={5}>
                          <Row className="align-items-center">
                            <Col lg={3} className="text-left">
                              <Form.Label>เบอร์โทรศัพท์</Form.Label>
                            </Col>
                            <Col lg={9}>
                            <div className={(!contact.phone | contact.phone.length === 0 && validated ? 'validate-fail-tags' : '') }>
                                <ReactTagInput
                                  placeholder="เบอร์โทรศัพท์"
                                  editable={true}
                                  readOnly={false}
                                  removeOnBackspace={true}
                                  maxTags={2}
                                  tags={contact.phone}
                                  required
                                  onChange={
                                    (newTags) => setData(prevState => ({
                                      ...Data,
                                      contacts: prevState.contacts.map(
                                        el => el.key === key ? { ...el, phone: newTags }: el
                                      )
                                    })) 
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12} sm={12} lg={1}  className="mt-2 mb-2">
                          {
                            key >= 1 
                            &&
                            <Button
                              type="button"
                              className="button-package"
                              onClick={() => RemoveContact(contact.key)}
                            >
                              <img src={Delete_Button} />
                            </Button>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2} className="mb-2">
                        {
                          Data.contacts?.length - 1 === key 
                          &&
                          <Button 
                            type="button" 
                            className="in-save" 
                            onClick={() => InsertContact()}
                          >
                            <img src={Increase} /> &nbsp; เพิ่มรายชื่อ
                          </Button>
                        }
                    </Col>
                  </Row>
                      </>
                      )
                    })
                  }
                  <Row className='mt-2'>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start align-items-center"
                        >
                          <Form.Label>หมายเหตุ</Form.Label>
                        </Col>
                        <Col>
                          <Form.Control 

                          as="textarea"
                          rows={3}
                          className="input-area-box"
                          value={Data.note}
                          onChange={(e) => setData({...Data, note: e.target.value})}
                        ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start align-items-center"
                        >
                          ชื่อผู้ใช้
                        </Col>
                        <Col>
                          <Form.Select 
                            className="select-style-bootrap" 
                            value={Data.employee_id} 
                            required 
                            onChange={(e) => setData({...Data, employee_id: e.target.value })}
                            >
                            <option hidden selected>เลือกพนักงาน</option>
                            {
                              Employees?.map(item => {
                                return (
                                  <option value={item.id}>{item.fullname}</option>
                                )
                              })
                            }
                          </Form.Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col>
                      <Row>
                        <Col
                          lg={3}
                          className="d-flex justify-content-start align-items-center"
                        >
                          หัวบิล
                        </Col>
                        <Col>
                          <Form.Control 
                            as="textarea"
                            placeholder="รายละเอียด"
                            rows={3}
                            className="input-area-box"
                            value={Data.bill_title}
                            onChange={(e) => setData({...Data, bill_title: e.target.value})}
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={5}></Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={10}
                  lg={8}
                  className="border-colum-time mt-4"
                >
                  <Row >
                    <Col ms={12} sm={12} lg={6}>
                      <Row >
                        <Col
                          xs={4}
                          sm={3}
                          md={3}
                          lg={3}
                          className="text-input d-flex justify-content-start align-items-center"
                        >
                          <p className='m-0'>เป้าขาย</p>
                        </Col>
                        <Col xs={8} sm={9} md={9} lg={9}>
                          <Form.Control
                            type="text"
                            // required
                            placeholder="เป้าขาย"
                            className="input-search-add-staff"
                            value={Data.sales_target ? addCommas(Data.sales_target) : '' }
                            onChange={(e) => setData({ ...Data, sales_target: e.target.value.replaceAll(',', '') })}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col ms={12} sm={12} lg={6}>
                      <Row>
                        <Col
                          xs={4}
                          sm={3}
                          md={3}
                          lg={3}
                          className="text-input d-flex justify-content-start align-items-center"
                        >
                          <p className='m-0'>ช่วงเวลา</p>
                        </Col>
                        <Col xs={8} sm={9} md={9} lg={9}>
                          <DatePicker.RangePicker
                            selected={Data.period}
                            onChange={(date) => setData({ ...Data, period: date })}
                            placeholder=""
                            suffixIcon={<img src={Calendar} />}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col className="mt-3 mb-3">
                  <Button type="submit" className="in-save ">
                    <img src={Save} /> &nbsp; บันทึก
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </Container>
      <Footer />
    </>
  );
}